var _rect, _path, _ellipse, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonitaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 51,
    viewBox: "0 0 109 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.7819,
    width: 85.2182,
    height: 51,
    rx: 10,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H99C104.523 0 109 4.47715 109 10V41C109 46.5228 104.523 51 99 51H29V0Z",
    fill: "url(#pattern0_91_26)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25.5,
    rx: 25,
    ry: 25.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94543,
    y: 10.2001,
    width: 35.6727,
    height: 33.8954,
    fill: "url(#pattern1_91_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_91_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_91_26",
    transform: "matrix(0.00454545 0 0 0.00713012 0 -0.0240642)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_91_26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_91_26",
    transform: "matrix(0.0197953 0 0 0.0208333 -0.0146789 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_91_26",
    width: 220,
    height: 147,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAACTCAMAAADSiocKAAAAD1BMVEUAkkbOKzf////j8+vvuLzvs62LAAAAn0lEQVR4nO3PMREAMAgEMKD1rxkTP3GJg1SlvAn5nRK7ycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJyZ3JLabCgKFGexRgAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_91_26",
    width: 52,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAwCAYAAABe6Vn9AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAU/SURBVHgB7VpLcttGEH1NKWXvzOyyE3QCMdtsxJxAyglEVaXyqSx8BFIniLNIyfEiok9g+wSkTyDlAiazyypidq5UCePXgwHZGIKkCpAILvyqugAOZkbd6O80JHg8dEknpI6IJM65xDybkW5IU9I70lvsMJ6TJiSnRGHmlI8FSs2cD7yeYceQkK5RZFqZtYwXfsMIFUjXt7ED6JBuEQlASvW31U6JpmK6RsNISJNckEigghD2Gu7TaDxfO0CDuELkL+Z3agS1zwpmiGUTVW03YnoJlv3ARdpSgbtmjd5fY40GA3XRAHrWdEqov2Kdvv0JFkKnecAwZvccDeANygVRpkYb1g5s1CsJFr+iAlqohzGy5Jgz5MF74WW4Ye2UyRYknavX+HklH9pHPfwWSBnqBCa0KniGrAJYh2m4qiT+HbhMKkEN1BXI4gbVkGvICoaqeEiB1sFrDlkCRrg/QtBOGJubXh2hHksgFeCMjHWDKSbmmQs+pkrRW2eEWOVPjaFLGtk8lIdlQ6vyVTx+hQbRDgykUfiNGY0TaJ6DyvJYJYEewuQSZDknyUN3MCM1H8l/h7m50095bfPatv6SWSLytY3h2mT7UpNCJvApir7ULZtvxhrRkJY+R8G5EZjyD1yG/5AJ8v4+mwXNuDxQbB38wxOU+0vuS2drlndhtGLPTeFaSUN1Sp9u1CeYa0nv+UwT7etNm1hfC2trhe06Ah2baAXDiITxTWbWCZPnezxEMKgj0GHwnTkTemsS5GzD+mMzV0qEqVSc1qq2y5zX/H62ZmlCOgmlgvUbi2NUQB2BlvJFKGHySNdZtbDVavWDZr1mci1Fwn2JikJVhR7A4gog7vKclqzro5ijCidWFHOSRtGt9RZ6WJ1My3oKOn8UMVwoi+Ix1EiwVaBv7lbKu6K2qZiWdXtQ7PysqufKfGst9lAdH0lP+QePTaUQI67nbETUez3tfhXqOjH+l9/POP4Nf/+DLUGLy6X2L6K3X/JcaRD26CIy3SD8BxRrv61BTW8ErOyvxfQvloNFPxJcX1KChtGDaSCW+M8EWYRbFbX6Ye4INSLbY5w7lBmbg7RimGJz5ZCvvc+8z/iMXUGjZ/cqcJcM8y1+uxVe3bzfN2XmmqLlhuJeMqoIhvLj5sNYk3C/M9DsyRuWs0mmh6UCwidu8RP3/VcExWBXBXN/MHelXiNTLPriioQa00K5o8V7dma+5KDIyEuvFa5zF7uuMQvy30NL/qTAf/nzkPxMiZ+4r6m0IYU55NDQvZIJ30rfC7tDUB+im7wgb7ekMz/Y0j45lbPnbqRkAaX1Gf1ATdIPiht7YVO898JvGf6l7pP51JdMmrR5kmTP4g7nyo97qdbFIJG6b2XlBkKhRHoF58t67GNupA2QMTcb4xHgrugr//so1iUfJ/zDB+FJ1qsQ+voP4bvUpfchLaumdJPDtWHbT97jAcvpUVilyZozWIQZdkX4XchRa47C7eNvvsUpvuDm55tLmLB/my+oQ6YOuEfi3/RSYRr+HKMx515YKwlmN+Q+Pfker++Vh3zs36PGnPkyrYXkvKegRaUT5IexRa9hhnltVmi9MVpJm0OLPex+hX1kxutbzrwoM3cKNNGXKT/h3P6VeyGod8Bl1Jj6mG2ShCbjPEVEbSnPMGQ5fyjPKhhQWCvITPspXqzStntFzaYM2U/wXT6ncqUQtHYazPFoSYC5aS6s0wyVaWbmzVf/M+sO76oGnwcpfbwTf+TbEv+ZMftiJxxz1KL4dtSCcRcYVeaFPnfHa4ob+aXyN9oCPgGc1gFMCWN5TgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonitaly);
export default __webpack_public_path__ + "static/media/Amazon italy.5a837f8bcb770b40d151d48f24dc7880.svg";
export { ForwardRef as ReactComponent };